import Field from './base';

export default class String extends Field {
  renderString(value) {
    return value && `${value}`.trim();
  }
}
